/* global fbq */
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "../HeaderNew/component";
import { useLocation, useNavigate } from "react-router-dom";
import CartHeader from "../../components/common/CartHeader";
import { Offcanvas, Modal } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import {
  notify,
  handleAddToCart,
  handleViewItem,
  errorCodeMessages,
} from "../../components/common/utils";
import { ToastContainer } from "react-toastify";
import { getProductDetails, updateCartItem } from "../../slices/catalogSlice";
import { MinusIcon, PlusIcon } from "../../components/svgicons";
import BrandLogo from "../../images/kikoimg.svg";
import ExternalLink from "../../images/home/external-link-icon.svg";
import Rightarrow from "../../images/right-arrow.svg";
import BackArrow from "../../images/left-arrow.svg";
import ShareIcon from "../../images/home/share-icon.svg";
import "./styles.scss";
import Loader from "../../components/common/loader";
import ProductCard from "../../components/common/product-card";
import Breadcrumb from "../../components/common/breadcrumb";
import Footer from "../../components/common/Footer";
import Login from "../Login/component";
import { v4 as uuidv4 } from "uuid";
import { ondcSelect } from "../../slices/ondcPreorderSlice";
import ManageAddress from "../ManageAddress/component";
import LoaderWhite from "../../components/common/LoaderWhite";
import StarRating from "../OrderDetails/starRating";
import MobileAddCart from "../../components/common/mobile-add-cart/index";

const ProductDetails = () => {
  const dispatch = useDispatch();
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const cartItems = useSelector((s) => s.catalog.cartItems);
  const ondcSelectstatus = useSelector((s) => s.ondcPreorder.ondcSelectstatus);
  const location = useLocation();
  const navigate = useNavigate();
  let catalogDataArray = location?.state?.catalogDataArray ?? [];
  const similarProducts = useSelector((s) => s.catalog.similarProducts);
  const otherProducts = useSelector((s) => s.catalog.catalogDataArray);
  const [similarItems, setSimilarItems] = useState(null);
  const [otherItems, setOtherItems] = useState(null);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const loading = useSelector((s) => s.catalog.getProductDetailsLoading);
  const catalogData = useSelector((s) => s.catalog.productDetails);
  const [isHeaderHide, setIsHeaderHide] = useState(false);
  const catalogDetailsDataArray = useSelector(
    (s) => s.catalog.catalogDataArray
  );
  const [selectLoading, setSelectLoading] = useState(false);
  const [addressModal, setAddressModal] = useState(false);
  const token = localStorage.getItem("token");
  const [cartError, setCartError] = useState("");
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const [shippingAddress, setShippingAddress] = useState(
    defaultAddress?.address
  );
  const [zipcode, setZipcode] = useState("");

  if (catalogDataArray.length === 0 || !catalogDataArray) {
    catalogDataArray = catalogDetailsDataArray;
  }
  const [singleCatalogData, setSingleCatalogData] = useState(null);
  const [varientId, setVarientId] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectLoadingId, setSelectLoadingId] = useState("");

  const getQueryParams = (queryString) => {
    return new URLSearchParams(queryString);
  };
  const queryParams = getQueryParams(location.search);
  const productCode = queryParams.get("productCode");
  const providerId = queryParams.get("providerId");
  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };
  const closeCart = () => {
    setIsCartOpen(false);
  };

  const getCatalogueDetails = async (id, providerId) => {
    try {
      const body = { id: id, providerId: providerId };
      dispatch(getProductDetails(body));
    } catch (error) {
      console.log("getCatalogueDetails : ERROR", error);
    }
  };

  useEffect(() => {
    setVarientId(productCode);
    getCatalogueDetails(productCode, providerId);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsHeaderHide(true);
      } else {
        setIsHeaderHide(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const itemIndex = cartItems?.filter(
      (item) => item._id === catalogData?.variants[0]._id
    );
    if (itemIndex && itemIndex.length > 0) {
      const varientArry = catalogData?.variants?.map((v) => {
        const index = cartItems?.findIndex((item) => item?._id === v?._id);
        if (index !== -1) {
          return { ...v, quantity: cartItems[index].quantity };
        } else {
          return { ...v, quantity: 0 };
        }
      });
      const temp = { ...catalogData, variants: varientArry };
      setSingleCatalogData(temp);
      const tempVariant = temp?.variants?.find(
        (item) => item._id === varientId
      );
      setSelectedVariant(tempVariant);
    } else {
      const varientArry = catalogData?.variants?.map((v) => {
        const index = cartItems?.findIndex((item) => item?._id === v?._id);
        if (index !== -1) {
          return { ...v, quantity: cartItems[index].quantity };
        } else {
          return { ...v, quantity: 0 };
        }
      });
      const temp = { ...catalogData, variants: varientArry };
      setSingleCatalogData(temp);
      const tempVariant = temp?.variants?.find(
        (item) => item._id === varientId
      );
      setSelectedVariant(tempVariant);
    }
    const product_data = { catalogData: catalogData };
  }, [catalogData, cartItems]);

  const handleSuccessfullLogin = () => {
    setModalIsOpen(false);
    setAddressModal(true);
  };

  useEffect(() => {
    updateSimilarProducts();
    updateOtherProducts();
  }, [similarProducts, otherProducts, cartItems]);

  const updateSimilarProducts = () => {
    if (!similarProducts) {
      setSimilarItems([]);
      return;
    }
    const data = similarProducts.map((product) => {
      const index = cartItems?.findIndex((item) => item?._id === product?._id);
      const mainQuantity = index !== -1 ? cartItems[index].quantity : 0;
      const updatedVariants =
        product?.variants?.map((variant) => {
          if (index !== -1) {
            return { ...variant, quantity: cartItems[index].quantity };
          } else {
            return { ...variant, quantity: 0 };
          }
        }) || [];
      return {
        ...product,
        quantity: mainQuantity,
        variants: updatedVariants,
      };
    });
    setSimilarItems([...data]);
  };

  const updateOtherProducts = () => {
    if (!otherProducts) {
      setOtherItems([]);
      return;
    }
    const data = otherProducts.map((product) => {
      const index = cartItems?.findIndex((item) => item?._id === product?._id);
      const mainQuantity = index !== -1 ? cartItems[index].quantity : 0;
      const updatedVariants =
        product?.variants?.map((variant) => {
          if (index !== -1) {
            return { ...variant, quantity: cartItems[index].quantity };
          } else {
            return { ...variant, quantity: 0 };
          }
        }) || [];
      return {
        ...product,
        quantity: mainQuantity,
        variants: updatedVariants,
      };
    });
    setOtherItems([...data]);
  };

  useEffect(() => {
    if (selectedVariant) {
      handleViewItem(
        selectedVariant?.productName,
        selectedVariant?._id,
        singleCatalogData?.subCategoryId,
        selectedVariant?.price,
        singleCatalogData?.store?.name
      );
    }
  }, [selectedVariant]);

  const regex = /^P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;
  const parseDuration = (duration) => {
    if (duration === "P0D") {
      return "A Few Seconds";
    }
    const match = duration.match(regex);
    if (!match) return duration;
    const days = parseInt(match[1] || 0, 10);
    const hours = parseInt(match[2] || 0, 10);
    const minutes = parseInt(match[3] || 0, 10);
    const seconds = parseInt(match[4] || 0, 10);
    let formattedDuration = "";
    if (days) formattedDuration += `${days} day${days > 1 ? "s" : ""} `;
    if (hours) formattedDuration += `${hours} hour${hours > 1 ? "s" : ""} `;
    if (minutes)
      formattedDuration += `${minutes} minute${minutes > 1 ? "s" : ""} `;
    if (seconds)
      formattedDuration += `${seconds} second${seconds > 1 ? "s" : ""}`;
    return formattedDuration.trim();
  };

  const formatTime = (minutes) => {
    if (minutes >= 1440) {
      const days = Math.floor(minutes / 1440);
      return `${days} day${days > 1 ? "s" : ""}`;
    } else if (minutes >= 60) {
      const hours = Math.floor(minutes / 60);
      return `${hours} hour${hours > 1 ? "s" : ""}`;
    } else {
      return `${minutes} minute${minutes > 1 ? "s" : ""}`;
    }
  };

  const dispatchOndcSelect = (updatedCartItems, productId, cb = () => { }) => {
    const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
    setSelectLoading(true);
    setSelectLoadingId(productId);
    if (!token) {
      setModalIsOpen(true);
      setSelectLoading(false);
      return;
    }
    if (!defaultAddress?.address?.address_line2) {
      setAddressModal(true);
      setSelectLoading(false);
      return;
    }
    setCartError("");
    const user = JSON.parse(localStorage.getItem("user"));
    const select_transaction_id = JSON.parse(
      localStorage.getItem("transaction_id")
    );
    const items = updatedCartItems?.map((item) => ({
      id: item.catalogData._id,
      quantity: item.quantity,
    }));
    const transaction_id = select_transaction_id
      ? select_transaction_id
      : uuidv4();
    dispatch(
      ondcSelect({
        userAddress: defaultAddress?.address,
        items,
        userId: user?._id,
        transactionId: transaction_id,
        landingSource: localStorage.getItem("landingSource")
          ? localStorage.getItem("landingSource")
          : "",
      })
    ).then((response) => {
      localStorage.setItem("transaction_id", JSON.stringify(transaction_id));
      setSelectLoading(false);
      setSelectLoadingId("");
      if (
        response?.payload?.success &&
        response?.payload?.data &&
        !response?.payload?.data?.error
      ) {
        cb(true);
      } else if (response?.payload?.data?.error?.message?.length > 0) {
        cb(false);
        try {
          const errorData = JSON.parse(response?.payload?.data?.error?.message);
          const errorItem = errorData?.find(
            (item) => item?.item_id === productId
          );
          const errorCode = errorItem?.error;
          let errorMessage = errorCode
            ? errorCodeMessages(errorCode) || ""
            : null;
          setCartError(errorMessage);
          if (typeof errorMessage !== "string") {
            errorMessage = "Uh-oh! Seller facing a technical issue";
          }
          notify(
            "error",
            errorMessage || "Uh-oh! Seller facing a technical issue"
          );
        } catch (e) {
          setCartError(response?.payload?.data?.error?.message);
          notify("error", response?.payload?.data?.error?.message);
          return;
        }
        const errMsg = response?.payload?.data?.error?.message
          ? response?.payload?.data?.error?.message
          : response?.payload?.message;
        const error = errorCodeMessages(
          response?.payload?.data?.error?.code,
          errMsg
        );
        if (!response?.payload?.data?.error?.code) {
          const err_with_id = `${errMsg}`;
          setCartError(err_with_id);
          notify("error", err_with_id);
        } else if (response?.payload?.data?.error?.code === "40002") {
          setCartError(error);
          notify("error", error);
        } else {
          const err_with_id = `${error}`;
          setCartError(err_with_id);
          notify("error", err_with_id);
        }
      } else {
        cb(false);
        notify("error", "Uh-oh! Seller facing a technical issue");
      }
    });
  };

  const updateCartItemQuantity = (
    itemId,
    newQuantity,
    singleCatalog,
    singleVariant,
    selectedItem,
    buyNow,
    addToCart
  ) => {
    const itemIndex = cartItems.findIndex((item) => item._id === itemId);
    if (newQuantity > parseInt(singleVariant?.availableQuantity)) {
      notify(
        "success",
        "Available Quantity is only " + singleVariant?.availableQuantity
      );
    } else if (newQuantity > parseInt(singleCatalog?.maximumQuantity)) {
      notify(
        "success",
        `Maximum quantity available is ${singleCatalog?.maximumQuantity} for this product`
      );
    } else {
      let updatedCartItems;
      if (itemIndex !== -1) {
        updatedCartItems = cartItems.map((item, index) => {
          if (index === itemIndex) {
            const updatedCatalogData = {
              ...item.catalogData,
              quantity: newQuantity,
              variants:
                item.catalogData?.variants?.map((variant) =>
                  variant._id === item._id
                    ? { ...variant, quantity: newQuantity }
                    : variant
                ) || [],
            };
            return {
              ...item,
              quantity: newQuantity,
              catalogData: updatedCatalogData,
            };
          }
          return item;
        });
        if (newQuantity === 0) {
          updatedCartItems = updatedCartItems.filter(
            (item) => item._id !== itemId
          );
        }
        if (selectedItem) {
          const cartItem = updatedCartItems.find((item) => item._id === itemId);
          const tempVariant = cartItem?.catalogData?.variants?.find(
            (variant) => variant._id === itemId
          );
          if (newQuantity > 0) {
            setSelectedVariant(tempVariant);
            setSingleCatalogData(cartItem?.catalogData);
          }
        }
      } else {
        if (newQuantity !== 0) {
          const varientArry = singleCatalog?.variants?.map((v) => {
            if (v._id === itemId) {
              return { ...v, quantity: newQuantity };
            } else {
              return v;
            }
          });
          const newCartItem = {
            _id: itemId,
            quantity: newQuantity,
            productId: singleVariant?.productId,
            catalogData: {
              ...singleCatalog,
              _id: singleVariant?._id,
              quantity: newQuantity,
              productName: singleVariant?.productName,
              productImages: singleVariant?.productImages,
              weight: singleVariant?.weight,
              weightUnit: singleVariant?.weightUnit,
              price: singleVariant?.price,
              description: singleVariant?.description,
              variants: varientArry,
            },
          };
          updatedCartItems = [...cartItems, newCartItem];
          if (selectedItem) {
            const cartItem = updatedCartItems.find(
              (item) => item._id === itemId
            );
            const tempVariant = varientArry?.find((v) => v._id === itemId);
            setSelectedVariant(tempVariant);
            setSingleCatalogData(cartItem?.catalogData);
          }
        } else {
          updatedCartItems = [...cartItems];
        }
      }
      const cartStorage = JSON.parse(localStorage.getItem("cart")) || [];
      const existingProviderId = cartStorage?.[0]?.catalogData?.providerId;
      if (
        existingProviderId &&
        updatedCartItems?.some(
          (item) => item?.catalogData?.providerId !== existingProviderId
        )
      ) {
        notify("error", "You can add items from a single store at a time.");
      } else {
        // if (localStorage.getItem("landingSource")?.includes("qc") && typeof fbq === 'function') {
        //   fbq('track', 'AddToCart', {
        //     content_name: singleVariant?.productName,
        //     content_ids: singleVariant?._id,
        //     value: singleVariant?.price
        //       ? parseFloat(singleVariant?.price)
        //       : 0,
        //     currency: 'INR',
        //   });
        // }
        if (newQuantity === 1 && addToCart && !existingProviderId) {
          dispatchOndcSelect(updatedCartItems, singleVariant?._id, (status) => {
            if (status) {
              handleAddToCart(
                singleVariant?.productName,
                singleVariant?._id,
                singleCatalog?.subCategoryId,
                newQuantity,
                singleVariant?.price,
                singleCatalog?.store?.name
              );
              localStorage.setItem("cart", JSON.stringify(updatedCartItems));
              dispatch(updateCartItem(updatedCartItems));
              if (buyNow) {
                toggleCart(!isCartOpen);
              }
            }
          });
        } else {
          handleAddToCart(
            singleVariant?.productName,
            singleVariant?._id,
            singleCatalog?.subCategoryId,
            newQuantity,
            singleVariant?.price,
            singleCatalog?.store?.name
          );
          localStorage.setItem("cart", JSON.stringify(updatedCartItems));
          dispatch(updateCartItem(updatedCartItems));
          if (buyNow) {
            toggleCart(!isCartOpen);
          }
        }
      }
    }
  };

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setVariant = (variant) => {
    if (variant) {
      setSelectedVariant(variant);
      setVarientId(variant?._id);
    }
  };

  const onPressViewAll = (providerId, subCategoryId) => {
    const encodedValue = encodeURIComponent(providerId);
    if (subCategoryId) {
      const encodedCategoryName = encodeURIComponent(subCategoryId);
      navigate(`/seller?pid=${encodedValue}&category=${encodedCategoryName}`);
    } else {
      navigate(`/seller?pid=${encodedValue}`);
    }
  };

  const ProductDetailSliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  const ProductDetailsSettings = {
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          dots: true,
          vertical: false,
          verticalSwiping: false,
        },
      },
      {
        breakpoint: 580,
        settings: {
          dots: true,
          infinite: true,
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const onPressCard = (item) => {
    setVarientId(item?._id);
    getCatalogueDetails(item?._id, item?.providerId);
    goToTop();
  };

  const onPressMinus = (item, singleCatalogData, selectedItem) => {
    const variant = singleCatalogData?.variants?.find(
      (v) => v._id === item._id
    );
    const newQuantity = variant?.quantity === 1 ? 0 : variant?.quantity - 1;
    updateCartItemQuantity(
      item?._id,
      newQuantity,
      singleCatalogData,
      item,
      selectedItem
    );
  };

  const onPressPlus = (item, singleCatalogData, selectedItem) => {
    const variant = singleCatalogData?.variants?.find(
      (v) => v._id === item._id
    );
    const newQuantity = variant?.quantity + 1;
    updateCartItemQuantity(
      item?._id,
      newQuantity,
      singleCatalogData,
      item,
      selectedItem
    );
  };

  const onPressAddToCart = (item, singleCatalogData, selectedItem) => {
    updateCartItemQuantity(
      item?._id,
      1,
      singleCatalogData,
      item,
      selectedItem,
      false,
      true
    );
  };
  return (
    <>
      <ToastContainer
        autoClose={300}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Header
        cartItemLength={cartItems?.length}
        hide={isHeaderHide}
        title={"Product Details"}
      />
      <div className="mobile-secondary-header-kl product-detail-mobile-header">
        <div className="mobile-secondary-header-inner-kl">
          <div className="mobile-secondary-header-title-kl">
            Product Details
          </div>
        </div>
      </div>
      {loading || !catalogData ? (
        <div className="dotLoader">
          <Loader />
        </div>
      ) : (
        <>
          {singleCatalogData && selectedVariant && (
            <Breadcrumb
              category={singleCatalogData?.subCategoryId}
              sellerDetails={singleCatalogData}
              selectedVariant={selectedVariant}
            />
          )}
          <div className="product-details-container-kl">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-details-container-inner-kl">
                    <div className="product-details-container-left">
                      <div className="product-details-card-kl p-md-0">
                        <div className="product-like-share-kl">
                          <div
                            className="product-like-share-items-kl"
                            onClick={() => {
                              const productLink = `${process.env.REACT_APP_URL
                                }/product-details?providerId=${providerId}&productCode=${selectedVariant?._id ?? ""
                                }`;
                              if (navigator.share) {
                                navigator
                                  .share({
                                    title: "Check this out",
                                    text: "Check out this page!",
                                    url: productLink,
                                  })
                                  .catch((err) =>
                                    console.error(
                                      "Error while sharing the url",
                                      err
                                    )
                                  );
                              } else {
                                alert("Sharing not supported on this browser.");
                              }
                            }}
                          >
                            <img src={ShareIcon} alt="like" />
                          </div>
                        </div>
                        <div className="mobile-item-details">
                          <div
                            onClick={() => {
                              navigate(-1);
                            }}
                            className="mobile-heading"
                          >
                            <img
                              alt="ArrowImage"
                              src={BackArrow}
                              style={{ maxWidth: "8px" }}
                            />
                            Item Details
                          </div>
                        </div>
                        <div className="product-detail-slider">
                          <div className="product-slider-container">
                            {selectedVariant?.productImages?.length > 1 && (
                              <Slider
                                asNavFor={nav1}
                                ref={(slider2) => setNav2(slider2)}
                                slidesToShow={
                                  selectedVariant?.productImages?.length > 5
                                    ? 6
                                    : selectedVariant?.productImages?.length
                                }
                                swipeToSlide={true}
                                focusOnSelect={true}
                                arrows={true}
                                centerMode={false}
                                infinite={false}
                                className="product-slider-as-nav"
                              >
                                {selectedVariant?.productImages?.map(
                                  (data, index) => (
                                    <div
                                      key={index}
                                      className="prodcutNavImage"
                                    >
                                      <img
                                        src={data}
                                        alt="Product Catalog"
                                        onError={(event) => {
                                          event.target.onerror = null;
                                          event.target.src = BrandLogo;
                                          event.target.classList.add(
                                            "default-img"
                                          );
                                        }}
                                      />
                                    </div>
                                  )
                                )}
                              </Slider>
                            )}
                            <Slider
                              {...ProductDetailsSettings}
                              slidesToShow={1}
                              slidesToScroll={1}
                              asNavFor={nav2}
                              ref={(slider1) => setNav1(slider1)}
                              className="product-slider"
                            >
                              {selectedVariant?.productImages?.map(
                                (data, index) => (
                                  <div key={index} className="prodcutImage">
                                    <img
                                      src={data}
                                      alt="Product Catalog"
                                      onError={(event) => {
                                        event.target.onerror = null;
                                        event.target.src = BrandLogo;
                                        event.target.classList.add(
                                          "default-img"
                                        );
                                      }}
                                    />
                                  </div>
                                )
                              )}
                            </Slider>
                            <div className="mobile-slider-block-container">
                              <Slider
                                {...settings}
                                className="mobile-slider-products"
                              >
                                {selectedVariant?.productImages?.map(
                                  (data, index) => (
                                    <div key={index} className="prodcutImage">
                                      <img
                                        src={data}
                                        alt="Product Catalog"
                                        onError={(event) => {
                                          event.target.onerror = null;
                                          event.target.src = BrandLogo;
                                          event.target.classList.add(
                                            "default-img"
                                          );
                                        }}
                                      />
                                    </div>
                                  )
                                )}
                              </Slider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="product-details-container-right">
                      <div className="product-details-card-kl">
                        <div className="product-details-content-kl">
                          <div className="product-details-title-kl">
                            {selectedVariant?.productName}
                          </div>
                          {selectedVariant?.averageRating && (
                            <div className="product-details-price-list-kl">
                              <div className="product-details-price-items-kl price-kl">
                                <StarRating
                                  value={selectedVariant?.averageRating}
                                  readOnly={true}
                                />
                              </div>
                              {selectedVariant?.averageRating.toFixed(1)}/5
                              &nbsp;&nbsp;
                              {selectedVariant?.ratingCount} ratings
                            </div>
                          )}
                          <div className="product-details-price-list-kl">
                            <div className="product-details-price-items-kl">
                              Price:
                            </div>
                            <div className="product-details-price-items-kl price-kl">
                              ₹{selectedVariant?.price}
                            </div>
                            {selectedVariant?.maximumPrice &&
                              parseFloat(selectedVariant?.maximumPrice) !==
                              parseFloat(selectedVariant?.price) && (
                                <div className="product-details-price-items-kl line-through">
                                  ₹{selectedVariant?.maximumPrice}
                                </div>
                              )}
                          </div>
                          <div className="product-sold-by-vender-source-kl">
                            <div className="product-sold-by-list-kl">
                              <div className="sold-by-title-kl">Sold By: </div>
                              <div
                                onClick={() => {
                                  onPressViewAll(singleCatalogData?.providerId);
                                }}
                                className="sold-by-name-kl"
                              >
                                {singleCatalogData?.store?.name ?? ""}
                                <img alt="Icon" src={ExternalLink} />
                              </div>
                            </div>
                            <div className="product-vender-source-list-kl">
                              <div className="vender-source-title-kl">
                                Vender Source:{" "}
                              </div>
                              <div className="vender-source-link-kl">
                                {singleCatalogData?.context?.bpp_id ?? ""}
                              </div>
                            </div>
                          </div>
                          <div className="product-manufactured-source-list-kl">
                            <div className="vender-source-title-kl">
                              Manufactured date:{" "}
                            </div>
                            <div className="vender-source-link-kl">
                              {singleCatalogData
                                ?.statutory_reqs_packaged_commodities
                                ?.month_year_of_manufacture_packing_import ??
                                "-"}
                            </div>
                          </div>
                          <div className="product-manufactured-source-list-kl">
                            <div className="vender-source-title-kl">
                              Expiry date:{" "}
                            </div>
                            <div className="vender-source-link-kl">
                              {"refer to back image"}
                            </div>
                          </div>
                          <div className="product-net-weight-source-list-kl">
                            <div className="vender-source-title-kl">
                              Net Weight
                            </div>
                            {singleCatalogData?.variants?.map((variant) => (
                              <button
                                type="button"
                                key={variant?._id}
                                onClick={() => setVariant(variant)}
                                className={
                                  selectedVariant?._id === variant?._id
                                    ? "product-details-quantity-kl active"
                                    : "product-details-quantity-kl"
                                }
                              >
                                {" "}
                                {variant?.weight + " " + variant?.weightUnit}
                              </button>
                            ))}
                          </div>
                          <div className="product-details-add-buy-btn-kl">
                            {cartItems.some(
                              (item) => item?._id === selectedVariant?._id
                            ) ? (
                              <div className="addtocart-qty">
                                <div
                                  className="addtocart-button button-down minus"
                                  onClick={() => {
                                    onPressMinus(
                                      selectedVariant,
                                      singleCatalogData,
                                      true
                                    );
                                  }}
                                >
                                  <MinusIcon />
                                </div>
                                <div className="addtocart-input">
                                  {selectedVariant?.quantity ?? ""}
                                </div>
                                <div
                                  className="addtocart-button button-up"
                                  value={selectedVariant?.quantity}
                                  onClick={() => {
                                    onPressPlus(
                                      selectedVariant,
                                      singleCatalogData,
                                      true
                                    );
                                  }}
                                >
                                  <PlusIcon />
                                </div>
                              </div>
                            ) : (
                              <button
                                type="button"
                                disabled={selectLoading}
                                className="btn  btn-outline add-to-cart-btn"
                                onClick={() => {
                                  onPressAddToCart(
                                    selectedVariant,
                                    singleCatalogData,
                                    true
                                  );
                                }}
                              >
                                <div className="dotLoader">
                                  {selectLoading &&
                                    selectLoadingId === selectedVariant?._id ? (
                                    <Loader />
                                  ) : (
                                    "Add To Cart"
                                  )}
                                </div>
                              </button>
                            )}
                            <button
                              type="button"
                              className="btn btn-primary add-to-cart-btn"
                              disabled={selectLoading}
                              onClick={() => {
                                const buyNowQuantity = selectedVariant?.quantity
                                  ? selectedVariant?.quantity
                                  : 1;
                                updateCartItemQuantity(
                                  selectedVariant?._id,
                                  buyNowQuantity,
                                  singleCatalogData,
                                  selectedVariant,
                                  false,
                                  true,
                                  true
                                );
                              }}
                            >
                              <div className="dotLoader">
                                {selectLoading &&
                                  selectLoadingId === selectedVariant?._id ? (
                                  <LoaderWhite />
                                ) : (
                                  "Buy Now"
                                )}
                              </div>
                            </button>
                            {cartItems.some(
                              (item) => item?._id === selectedVariant?._id
                            ) && (
                                <button
                                  type="button"
                                  className="btn  btn-outline add-to-cart-btn"
                                  disabled={selectLoading}
                                  onClick={() => {
                                    updateCartItemQuantity(
                                      selectedVariant?._id,
                                      0,
                                      singleCatalogData,
                                      selectedVariant
                                    );
                                  }}
                                >
                                  Remove Item
                                </button>
                              )}
                          </div>
                        </div>
                        <div className="accordion" id="accordionExample">
                          <div className="accordion-item">
                            <h2 className="accordion-header " id="headingOne">
                              <button
                                className="accordion-button product-details-card-title-kl"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseProductDetails"
                                aria-expanded="true"
                                aria-controls="collapseProductDetails"
                              >
                                Product Details
                              </button>
                            </h2>
                            <div
                              id="collapseProductDetails"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingOne"
                            >
                              <div className="accordion-body">
                                <div className="product-detail-card-kl">
                                  <div className="product-details-card-list-kl">
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        Product Name:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">
                                        {selectedVariant?.productName ?? ""}
                                      </div>
                                    </div>
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        Net Weight:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">{`${selectedVariant?.weight ?? ""
                                        } ${selectedVariant?.weightUnit ?? ""
                                        }`}</div>
                                    </div>
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        Country Of Origin:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">
                                        India
                                      </div>
                                    </div>
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        EAN / Barcode number:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">
                                        {singleCatalogData?.code ?? "-"}
                                      </div>
                                    </div>
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        Time To Ship:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">
                                        {" "}
                                        {singleCatalogData?.timeToShip
                                          ? formatTime(
                                            singleCatalogData?.timeToShip
                                          )
                                          : "-"}
                                      </div>
                                    </div>
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        Cancellable:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">
                                        {singleCatalogData?.isCancellable
                                          ? "Yes"
                                          : "No"}
                                      </div>
                                    </div>
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        Returnable:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">
                                        {singleCatalogData?.isReturnable
                                          ? "Yes"
                                          : "No"}
                                      </div>
                                    </div>
                                    {singleCatalogData?.isReturnable && (
                                      <div className="product-details-card-items-kl">
                                        <div className="product-details-list-title-kl">
                                          Returnable Window:
                                        </div>
                                        <div className="product-details-list-sub-title-kl">
                                          {singleCatalogData?.returnWindowTime
                                            ? parseDuration(
                                              singleCatalogData?.returnWindowTime
                                            )
                                            : "-"}
                                        </div>
                                      </div>
                                    )}
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        Manufacture Name:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">
                                        {singleCatalogData
                                          ?.statutory_reqs_packaged_commodities
                                          ?.manufacturer_or_packer_name ?? "NA"}
                                      </div>
                                    </div>
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        Nutritional Information:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">
                                        {singleCatalogData?.nutritionalInfo
                                          ?.nutritional_info ?? "NA"}
                                      </div>
                                    </div>
                                    <div className="product-details-card-items-kl">
                                      <div className="product-details-list-title-kl">
                                        Addictive Information:
                                      </div>
                                      <div className="product-details-list-sub-title-kl">
                                        {singleCatalogData?.nutritionalInfo
                                          ?.additives_info ?? "NA"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="accordion-item">
                            <h2 className="accordion-header " id="headingTow">
                              <button
                                className="accordion-button product-details-card-title-kl"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseProductDescription"
                                aria-expanded="true"
                                aria-controls="collapseProductDescription"
                              >
                                Product Description
                              </button>
                            </h2>
                            <div
                              id="collapseProductDescription"
                              className="accordion-collapse collapse show"
                              aria-labelledby="headingTow"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordion-body">
                                <div className="product-details-description-kl">
                                  <div className="product-desc-kl">
                                    {singleCatalogData?.description}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="product-details-tabs-container-kl">
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#Description"
                >
                  Description
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#ProductDetails"
                >
                  Product Details
                </a>
              </li>
            </ul>
            <div className="tab-content">
              <div className="tab-pane container active" id="Description">
                <div className="product-details-description-kl">
                  <div className="product-desc-kl">
                    {singleCatalogData?.description}
                  </div>
                </div>
              </div>
              <div className="tab-pane container fade" id="ProductDetails">
                <div className="product-details-card-list-kl">
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      Product Name:
                    </div>
                    <div className="product-details-list-sub-title-kl">
                      {selectedVariant?.productName ?? ""}
                    </div>
                  </div>
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      Net Weight:
                    </div>
                    <div className="product-details-list-sub-title-kl">{`${selectedVariant?.weight ?? ""
                      } ${selectedVariant?.weightUnit ?? ""}`}</div>
                  </div>
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      Country Of Origin:
                    </div>
                    <div className="product-details-list-sub-title-kl">
                      India
                    </div>
                  </div>
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      EAN / Barcode number:
                    </div>
                    <div className="product-details-list-sub-title-kl">
                      {singleCatalogData?.code ?? "-"}
                    </div>
                  </div>
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      Time To Ship:
                    </div>
                    <div className="product-details-list-sub-title-kl">
                      {" "}
                      {singleCatalogData?.timeToShip
                        ? formatTime(singleCatalogData?.timeToShip)
                        : "-"}
                    </div>
                  </div>
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      Cancellable:
                    </div>
                    <div className="product-details-list-sub-title-kl">
                      {singleCatalogData?.isCancellable ? "Yes" : "No"}
                    </div>
                  </div>
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      Returnable:
                    </div>
                    <div className="product-details-list-sub-title-kl">
                      {singleCatalogData?.isReturnable ? "Yes" : "No"}
                    </div>
                  </div>
                  {singleCatalogData?.isReturnable && (
                    <div className="product-details-card-items-kl">
                      <div className="product-details-list-title-kl">
                        Returnable Window:
                      </div>
                      <div className="product-details-list-sub-title-kl">
                        {singleCatalogData?.returnWindowTime
                          ? parseDuration(singleCatalogData?.returnWindowTime)
                          : "-"}
                      </div>
                    </div>
                  )}
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      Manufacture Name:
                    </div>
                    <div className="product-details-list-sub-title-kl">
                      {singleCatalogData?.statutory_reqs_packaged_commodities
                        ?.manufacturer_or_packer_name ?? "NA"}
                    </div>
                  </div>
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      Nutritional Information:
                    </div>
                    <div className="product-details-list-sub-title-kl">
                      {singleCatalogData?.nutritionalInfo?.nutritional_info ??
                        "NA"}
                    </div>
                  </div>
                  <div className="product-details-card-items-kl">
                    <div className="product-details-list-title-kl">
                      Addictive Information:
                    </div>
                    <div className="product-details-list-sub-title-kl">
                      {singleCatalogData?.nutritionalInfo?.additives_info ??
                        "NA"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {similarItems && similarItems?.length > 0 && (
            <section className="similar-product-section-kl">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="section-heading-container-kl">
                      <div className="section-heading-title-kl">
                        Similar Products
                      </div>
                      <button
                        type="button"
                        className="view-all-btn-kl"
                        onClick={() => {
                          onPressViewAll(
                            similarItems?.[0]?.providerId,
                            similarItems?.[0]?.subCategoryId
                          );
                        }}
                      >
                        View All
                        <img
                          alt="Icon"
                          src={Rightarrow}
                          className="mobile-right-arrow"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container">
                {similarItems && similarItems?.length > 0 && (
                  <Slider {...ProductDetailSliderSettings}>
                    {similarItems && similarItems.length > 0 ? (
                      similarItems?.map((data, index) => (
                        <ProductCard
                          key={index}
                          data={data}
                          navigate={navigate}
                          setVariant={setVariant}
                          cartItems={cartItems}
                          onPressCard={() => {
                            onPressCard(data);
                          }}
                          onPressAddToCart={() => {
                            onPressAddToCart(data, data, false);
                          }}
                          onPressMinus={() => {
                            onPressMinus(data, data, false);
                          }}
                          onPressPlus={() => {
                            onPressPlus(data, data, false);
                          }}
                          selectLoading={selectLoading}
                          selectLoadingId={selectLoadingId}
                        />
                      ))
                    ) : (
                      <p>Loading similar products...</p>
                    )}
                  </Slider>
                )}
              </div>
            </section>
          )}
          {otherItems && otherItems?.length > 0 && (
            <section className="other-product-section-kl">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="section-heading-container-kl">
                      <div className="section-heading-title-kl">
                        {`Other Products Sold by ${singleCatalogData?.store?.name ?? "this store"
                          }`}
                      </div>
                      <button
                        type="button"
                        className="view-all-btn-kl"
                        onClick={() => {
                          onPressViewAll(otherItems?.[0]?.providerId);
                        }}
                      >
                        View All
                        <img
                          alt="Icon"
                          src={Rightarrow}
                          className="mobile-right-arrow"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container">
                {otherItems && otherItems?.length > 0 && (
                  <Slider {...ProductDetailSliderSettings}>
                    {otherItems && otherItems.length > 0 ? (
                      otherItems?.map((data, index) => (
                        <ProductCard
                          key={index}
                          data={data}
                          navigate={navigate}
                          setVariant={setVariant}
                          cartItems={cartItems}
                          onPressCard={() => {
                            onPressCard(data);
                          }}
                          onPressAddToCart={() => {
                            onPressAddToCart(data, data, false);
                          }}
                          onPressMinus={() => {
                            onPressMinus(data, data, false);
                          }}
                          onPressPlus={() => {
                            onPressPlus(data, data, false);
                          }}
                          selectLoading={selectLoading}
                          selectLoadingId={selectLoadingId}
                        />
                      ))
                    ) : (
                      <p>Loading products...</p>
                    )}
                  </Slider>
                )}
              </div>
            </section>
          )}
          {modalIsOpen && (
            <Login
              isOpenFromCart={true}
              modalIsOpen={modalIsOpen}
              setModalIsOpen={setModalIsOpen}
              onSuccess={handleSuccessfullLogin}
            ></Login>
          )}
          <Modal
            isOpen={addressModal}
            size="lg"
            toggle={() => setAddressModal(false)}
            className="custom-modal-kl"
          >
            <div className="addressmodalBlock">
              <ManageAddress
                onAddressSelected={dispatchOndcSelect}
                setZipcode={setZipcode}
                setAddressModal={setAddressModal}
                setShippingAddress={setShippingAddress}
                zipcode={zipcode}
                isInHeader={false}
              />
            </div>
          </Modal>
          <Footer />
        </>
      )}
      <Offcanvas
        isOpen={isCartOpen}
        toggle={closeCart}
        direction="end"
        backdrop={ondcSelectstatus === "loading" ? "static" : true}
        className="offcanvas offcanvas-end sidebaroffcanvas"
      >
        <CartHeader isCartOpen={isCartOpen} closeCart={closeCart} />
      </Offcanvas>

      <MobileAddCart itemCount={cartItems?.length} hide={isCartOpen} />
    </>
  );
};
export default ProductDetails;
